import PropTypes from 'prop-types';
import React from 'react';
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import {grey} from '@material-ui/core/colors';

const grey100 = grey[100];
const ozgeneBlue = '#3357b8';
const ozgeneOrange = '#de7c1b';
const muiTheme = createMuiTheme({
  tableRow: {
    selectedColor: 'inherit',
  },
  palette: {
    primary1Color: ozgeneBlue,
    accent1Color: ozgeneOrange,
  },
  toolbar: {
    backgroundColor: grey100,
  },
  props: {
    MuiTextField: {
      variant: 'outlined',
    },
  },
  fontFamily: 'Roboto',
});
const Theme = (props) => {
  const {children} = props;

  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>;
};

Theme.propTypes = {
  children: PropTypes.element.isRequired,
};

export default Theme;
